import { render } from "./ContractAcceptedDetails.vue?vue&type=template&id=059c6f38&scoped=true"
import script from "./ContractAcceptedDetails.vue?vue&type=script&lang=js"
export * from "./ContractAcceptedDetails.vue?vue&type=script&lang=js"

import "./ContractAcceptedDetails.vue?vue&type=style&index=0&id=059c6f38&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059c6f38"]])

export default __exports__